export default __webpack_public_path__ + "static/media/onlineClouds.954cc50e.jpg";